<article class="schedule-details-modal"
  [ngClass]="{'schedule-details-modal--dialog':
    appService.isWide}">

  <!-- Desktop dialog header -->
  @if (appService.isWide) {
    <h2 mat-dialog-title
      id="aria_schedule_details"
      tabindex="-1">
      {{ title }}
    </h2>
  }
  @if (appService.isWide && subtitle) {
    <div
      class="schedule-details-modal__subtitle">
      {{ subtitle }}
    </div>
  }

  <!-- Narrow full-page modal header -->
  @if (appService.isNarrow) {
    <app-full-page-dialog-header
      [title]="title"
      [subtitle]="subtitle"
      ariaId="aria_schedule_details"
      [closeAriaLabel]="backAriaLabel"
      (closed)="closed.emit()">
    </app-full-page-dialog-header>
  }

  @if (schedule) {
    @if (appService.isWide) {
      <div mat-dialog-content
        class="schedule-details-modal__content">
        <ng-container *ngTemplateOutlet="modalBody">
        </ng-container>
      </div>
    }
    @if (appService.isNarrow) {
      <div class="schedule-details-modal__content">
        <ng-container *ngTemplateOutlet="modalBody">
        </ng-container>
      </div>
    }
  }

  <ng-template #modalBody>
    @if (schedule?.paymentMethod) {
      <app-payment-method-display
        class="schedule-details-modal__payment-method"
        [isECheck]="isPaymentMethodECheck"
        [last4Digits]="schedule.paymentMethod.last4Digits"
        [cardType]="schedule.paymentMethod.cardType">
      </app-payment-method-display>
    }

    <teller-online-schedule-details
      [schedule]="scheduleView"
      [currentPaymentId]="currentPaymentId"
      ariaLabelledBy="aria_schedule_details"
      (rowClick)="on_rowClick($event)">
    </teller-online-schedule-details>

    @if (canCancel) {
      <form [formGroup]="cancelScheduleForm">
        <mat-checkbox formControlName="confirmCancel"
          required>
          I understand that cancelling this schedule
          will also cancel all future payments
          associated with it.
        </mat-checkbox>
      </form>
    }
  </ng-template>

  @if (appService.isWide) {
    <div mat-dialog-actions
      class="schedule-details-modal__actions"
      align="end">
      <button matButton
        (click)="closed.emit()">
        Close
      </button>
      @if (canCancel) {
        <button matButton class="warn"
          [disabled]="!cancelScheduleForm.valid"
          (click)="onClick_cancel()">
          Cancel Schedule
        </button>
      }
    </div>
  }

  @if (appService.isNarrow) {
    <div class="schedule-details-modal__actions">
      @if (canCancel) {
        <button matButton class="warn"
          [disabled]="!cancelScheduleForm.valid"
          (click)="onClick_cancel()">
          Cancel Schedule
        </button>
      }
    </div>
  }
</article>
